import { render, staticRenderFns } from "./DiscountCalcOld.vue?vue&type=template&id=6a92ed2c"
import script from "./DiscountCalcOld.vue?vue&type=script&lang=js"
export * from "./DiscountCalcOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports